import { ConfigFn } from '@config/types'

const config = (() =>
  ({
    baseUrl: {
      media: 'https://cdn.jwplayer.com/v2/media/',
    },
    staticPlayerParams: {
      horizontalVolumeSlider: true,
      renderCaptionsNatively: false,
      // default values
      aspectratio: '16:9',
      displayHeading: false,
      displaydescription: false,
      displaytitle: false,
      height: 270,
      preload: 'none',
      stretching: 'exactfit',
      width: '100%',
      floating: {
        dismissible: true,
        mode: 'never',
      },
    },
  }) as const) satisfies ConfigFn

export default config
